import { useLeague, useLeagueMaxTokens } from '../../../hooks';
import { Spin } from '../../spin';
import './card-display.css';

import { Sparkles } from 'lucide-react';

export function CardDisplay() {
  const { maxTokens } = useLeagueMaxTokens();
  const { league, currentSeason, loading } = useLeague();

  return (
    <div className="card-display">
      <div className="card-display-header">
        <Sparkles className="card-display-icon" stroke="#CAFB10" />
        <h3 className="card-display-title">Tarjeta de la Temporada</h3>
      </div>

      <div className="card-display-card">
        <div className="card-display-overlay" />

        <div className="card-display-top">
          <div className="card-display-season-label">TEMPORADA ACTUAL</div>
          <div className="card-display-name">{currentSeason?.cardName}</div>
        </div>

        {currentSeason?.cardImg ? (
          <>
            <div className="card-display-img-container">
              <div className="card-display-darklayer" />
              <img
                className="card-display-img"
                src={currentSeason.cardImg}
                alt="TARJETA"
              />
            </div>
          </>
        ) : (
          <div className="card-display-diamond">{league?.icon}</div>
        )}

        <div className="card-display-bottom">
          <div className="card-display-token-box">
            <div className="card-display-token-label">Token Único</div>
            <div className="card-display-token-range">
              #1 - {loading ? <Spin /> : <>#{maxTokens}</>}{' '}
            </div>
          </div>
        </div>
      </div>

      <div className="card-display-footer">
        Cada tarjeta contiene un token único e irrepetible
      </div>
    </div>
  );
}
